import sessionAuthApi from "./sessionAuth";
import { handleEmbedUnauthorized } from "./embedRuntime";

/**
 * Custom auth (Keycloak behind the API). No Keycloak browser redirect.
 */
const authService = {
  isLoggingOut: () => false,

  login: () => {
    if (handleEmbedUnauthorized()) return;
    if (!window.location.pathname.startsWith("/login")) {
      window.location.assign("/login");
    }
  },

  logout: async () => {
    await sessionAuthApi.logout();
    window.location.assign("/login");
  },

  getUser: () => sessionAuthApi.getUser(),

  getAccessToken: () => sessionAuthApi.getAccessToken(),

  /** @deprecated OIDC callback removed */
  handleCallback: async () => sessionAuthApi.getUser(),

  loginWithPassword: (username: string, password: string) => sessionAuthApi.login(username, password),
};

export default authService;
